/* eslint-disable */
import * as R from 'ramda';
import {
  addMinutes,
  startOfDay,
  setHours,
  format,
  areIntervalsOverlapping,
} from 'date-fns/fp';

export const dateFormat = 'MM/dd/yyyy';
export const timeDisplayFormat = 'h:mm a';
export const appointmentDateFormat = 'EEEE, MMMM do yyyy \n ';
export const appointmentTimeFormat = 'h:mma';

const formatDate = format(dateFormat);
const formatTime = format(timeDisplayFormat);

export const humanDate = formatDate;

export const humanTime = formatTime;

// Time slot duration in minutes (60 = 1 hour)
const SLOT_DURATION = 60;

export const addMinutesToLast = R.converge(R.append, [
  R.pipe(R.last, addMinutes(SLOT_DURATION)),
  R.identity,
]);

// Number of slots: 8 slots x 60 mins = 8 hours (9am - 5pm)
export const getTimeSlotArray = R.pipe(
  R.when(R.isNil, R.always(new Date())),
  startOfDay,
  setHours(9),
  R.of,
  R.until(R.pipe(R.length, R.lte(8)), addMinutesToLast),
);

export const getInterval = R.applySpec({
  start: R.identity,
  end: addMinutes(SLOT_DURATION),
});

export const checkTimeWithinInterval = (time) => (interval) =>
  areIntervalsOverlapping(interval)({
    start: time,
    end: addMinutes(SLOT_DURATION)(time),
  });

export const checkTimeSlot = (time) =>
  R.map(
    R.pipe(
      R.map(R.map((d) => new Date(d))),
      R.any(checkTimeWithinInterval(time)),
    ),
  );
